import { LabelHTMLAttributes } from 'react'
import * as S from './styles'

type Props = LabelHTMLAttributes<HTMLLabelElement>

export function Label({ children, ...props }: Props) {
  return <S.Label {...props}>
    {children}
  </S.Label>
}